import { createStandardAction } from 'typesafe-actions';

const updateLoading = createStandardAction('updateLoading')<boolean>();

export default updateLoading;
